




























































































import { opportunityGrantRolePermissions } from '@/auth';
import { OpportunityGeeksCounters, OpportunityFilter } from '@/components/opportunities';
import {GeekItemWithRole, PhraseSearchFilter, SearchFilter} from '@/models';
import { Role, Counter } from '@/models/opportunities';
import { Actions, typedStore } from '@/store';
import { ToastsService } from '@/utils';
import { debounce } from 'lodash';
import Vue from 'vue';

export default Vue.extend({
  name: 'OpportunityPermissionsView',
  components: {
    OpportunityGeeksCounters,
    OpportunityFilter,
  },
  data() {
    return {
      loader: {
        isGeeksWithRolesListPending: true,
      },
      filters: {
        debounce: {
          searchPhrase: '',
        } as PhraseSearchFilter,
      },
    };
  },
  async created(): Promise<void> {
    try {
      await this.$store.dispatch(Actions.opportunities.fetchGeeksWithRoles);
      await this.$store.dispatch(Actions.opportunities.fetchGeeksCounters);
    } finally {
      this.loader.isGeeksWithRolesListPending = false;
    }
  },
  computed: {
    counters(): Counter[] {
      return typedStore(this).state.opportunities.counters;
    },
    geeks(): GeekItemWithRole[] {
      return typedStore(this).state.opportunities.geeksWithRoles;
    },
    geeksCount(): number {
      return typedStore(this).state.opportunities.pagination.totalCount;
    },
    areMoreItemsAvailable(): boolean {
      return this.geeks.length < this.geeksCount && this.geeks.length > 0;
    },
    roleOptions(): Role[] {
      return typedStore(this).state.geek.current.permissions
        .filter(p => opportunityGrantRolePermissions[p])
        .map(p => opportunityGrantRolePermissions[p]) as Role[];
    },
  },
  methods: {
    async loadGeeksWithRoles() {
      this.loader.isGeeksWithRolesListPending = true;
      try {
        await this.$store.dispatch(Actions.opportunities.fetchGeeksWithRoles, this.filters.debounce);
      } finally {
        this.loader.isGeeksWithRolesListPending = false;
      }
    },
    async loadMoreGeeksWithRoles() {
      this.loader.isGeeksWithRolesListPending = true;
      try {
        await this.$store.dispatch(Actions.opportunities.fetchMoreGeeksWithRoles, this.filters.debounce);
      } finally {
        this.loader.isGeeksWithRolesListPending = false;
      }
    },
    async changeRole(geekWithRole: GeekItemWithRole, role: Role) {
      this.loader.isGeeksWithRolesListPending = true;
      try {
        await this.$store.dispatch(Actions.opportunities.changeGeekRole, { geekWithRole, role });
        await this.$store.dispatch(Actions.opportunities.fetchGeeksCounters);
        geekWithRole.role = role;
        ToastsService.success(
          this.$t(
            'opportunities.permissions.notifications.geek-role-updated',
            {
              firstName: geekWithRole.geek.firstName,
              nick: geekWithRole.geek.nick,
              lastName: geekWithRole.geek.lastName,
            },
          ) as string,
        );
      } finally {
        this.loader.isGeeksWithRolesListPending = false;
      }
    },
    isRoleChangeDisabled(geekItemWithRole: GeekItemWithRole): boolean {
      return geekItemWithRole.geek.id === typedStore(this).state.geek.current.id
        || !typedStore(this).state.geek.current.permissions
          .some(p => opportunityGrantRolePermissions[p] === geekItemWithRole.role);
    },
    updateSearchPhrase: debounce(function(this: any) {
      this.filters.debounce.searchPhrase = this.$refs.searchPhrase.$el.value;
    }, 1000),
  },
  watch: {
    filters: {
      handler() {
        this.loadGeeksWithRoles();
      },
      deep: true,
    },
  },
});
